var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-container",attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper subscription-constructor_page"},[_c('header-transparent'),_c('main',{staticClass:"main"},[_c('router-view')],1)],1),_c('footer-base')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }